import { gql } from '@apollo/client'

export const ACTION_INSERT = gql`
  mutation ActionInsert($data: d4_action_insert_input!) {
    action: insert_d4_action_one(object: $data) {
      id
      daterealisation
      demande_id
    }
  }
`

export const ACTION_UPDATE = gql`
  mutation ActionUpdate($id: bigint!, $data: d4_action_set_input!) {
    action: update_d4_action_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      daterealisation
      demande_id
    }
  }
`
